import { render } from "./phb.vue?vue&type=template&id=2db9e5a6&scoped=true"
import script from "./phb.vue?vue&type=script&lang=js"
export * from "./phb.vue?vue&type=script&lang=js"

import "./phb.vue?vue&type=style&index=0&id=2db9e5a6&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db9e5a6"]])

export default __exports__